/**
 * storageService.js
 * Servicio de almacenamiento de imágenes usando Cloudinary.
 * Reemplaza Firebase Storage que requiere plan de pago.
 */

const CLOUDINARY_CLOUD_NAME = "bg5vpulc";
const CLOUDINARY_UPLOAD_PRESET = "Wishlu";

/**
 * Comprime una imagen antes de subirla.
 * - Limita el lado más largo a 1200px (mantiene proporción)
 * - Convierte a JPEG con calidad 0.75
 * - Si algo falla, devuelve el archivo original sin comprimir
 */
export function compressImage(file) {
  return new Promise((resolve) => {
    const img = new window.Image();
    const url = URL.createObjectURL(file);

    img.onload = () => {
      URL.revokeObjectURL(url);

      const MAX = 1200;
      let w = img.width;
      let h = img.height;

      if (w > MAX || h > MAX) {
        if (w > h) {
          h = Math.round((h * MAX) / w);
          w = MAX;
        } else {
          w = Math.round((w * MAX) / h);
          h = MAX;
        }
      }

      const canvas = document.createElement("canvas");
      canvas.width = w;
      canvas.height = h;
      canvas.getContext("2d").drawImage(img, 0, 0, w, h);

      canvas.toBlob(
        (blob) => resolve(blob || file),
        "image/jpeg",
        0.75
      );
    };

    img.onerror = () => resolve(file);
    img.src = url;
  });
}

/**
 * Sube una foto a Cloudinary y devuelve su URL pública.
 * - Guarda en la carpeta "gifts"
 * - onProgress se llama con 0 al inicio y 100 al terminar
 *   (Cloudinary no da progreso en tiempo real con fetch)
 *
 * Devuelve: Promise<string> con la URL de la imagen
 */
export async function uploadPhoto(file, uid, onProgress = null) {
  if (onProgress) onProgress(10);

  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", CLOUDINARY_UPLOAD_PRESET);
  formData.append("folder", "gifts");
  formData.append("public_id", uid + "_" + Date.now());

  const response = await fetch(
    `https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_NAME}/image/upload`,
    { method: "POST", body: formData }
  );

  if (!response.ok) {
    throw new Error("Cloudinary upload failed: " + response.statusText);
  }

  const data = await response.json();

  if (!data.secure_url) {
    throw new Error("Cloudinary did not return a URL");
  }

  if (onProgress) onProgress(100);
  return data.secure_url;
}
